import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityMelunPage() {
  const data = citiesData.find((c) => c.slug === "melun")!;
  return <CityPage data={data} />;
}
